<template>
  <b-card>
      <!-- Form -->
      <b-form class="p-2">
        <b-row>
          <b-col sm="12">
            <b-form-group label="Kode Ujian" label-for="kode">
              <b-form-input
                v-model="userData.kode"
                name="kode"
                placeholder="kode ujian"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group label="Tempat Test" label-for="tempat_test">
              <b-form-input
                v-model="userData.tempat_test"
                name="tempat_test"
                placeholder="tempat test"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group label="Tanggal" label-for="tanggal">
              <b-form-input
                v-model="userData.tanggal"
                name="tanggal"
                placeholder="tanggal"
                type="date"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group label="Waktu TKD" label-for="waktu_tkd">
              <b-form-input
                v-model="userData.waktu_tkd"
                name="waktu tkd"
                placeholder="waktu tkd"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group label="Durasi" label-for="durasi">
              <b-form-input
                v-model="userData.durasi"
                name="durasi"
                placeholder="durasi"
                type="number"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            @click="updateData"
          >
            Simpan
          </b-button>
        </div>
      </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol, BBadge,
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback,
  BFormSpinbutton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { required, alphaNum, email } from '@validations'
import moment from 'moment'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    var userData = this.rowData.data
    return {
      userData,
      required,
      alphaNum,
      email,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async updateData() {
      store.dispatch('jadwal-ujian/updateData', this.rowData.data)
        .then(response => {
          this.makeToast('success', 'Simpan Data Jadwal Ujian Berhasil Dilakukan')
          setTimeout(() => {
            this.$router.push({name: 'jadwal-ujian'})
          }, 3000);
        })
        .catch(error => {
          console.error(error)
        })
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate(value, format) {
      return moment(String(value)).format(format)
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Jadwal Ujian',
        variant,
        solid: true,
        autoHideDelay: 3000,
      })
    },
    mappingSelectOptionIds(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.ids,
          })
        })
      }
    },
  },
}
</script>

<style>
</style>
